// extracted by mini-css-extract-plugin
module.exports = {"modal":"MetadataModal_modal__1uZlO"};